/*** 
 * 创建人：李珊
 * 时间：2021-3-24
 * 描述：通用字典的新增 修改模态框
 * 更新说明:
 */
 import { Component, OnInit, Output, EventEmitter,ViewChild, Input} from '@angular/core';
 import {SwMassageBoxService} from "../../../../../librarys/serves/sw-massage-box.service";
 import {SwJwtService} from "../../../../../librarys/serves/sw-jwt.service";
 import { KmsService } from "../../../kms.service"
 import {OninitService} from "../../../../../librarys/serves/oninit.service";
 import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
 import { NgForm } from '@angular/forms';
 import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
 @Component({
  selector: 'app-dictionary-add',
  templateUrl: './dictionary-add.component.html',
  styleUrls: ['./dictionary-add.component.css']
})
export class DictionaryAddComponent implements OnInit {
 
   headerLoGo: any; //标题展示信息
   dicModels: any = {}; //数据对象
   parentMenu=[]; //树形数据 
   invalid: boolean = false; //判断表单保存是否符合条件
   @ViewChild('modal') modal: SwModalframeComponent; //模态框组件
   @ViewChild('f') f: NgForm; //表格对象
 
   constructor(
     private box:SwMassageBoxService,//消息框
     private jwt:SwJwtService, //浏览器缓存
     private kmsService:KmsService, //请求服务
     private init:OninitService, //页面初始化方法
     private systemId:SystemIdService
   ) { }
 
   @Input() param:any;
   @Output() callback = new EventEmitter(); //抛出事件
   ngOnInit() {
     this.location();
     this.clickLoca(this.param["view"],this.param["viewData"])
   }
   //初始化方法树型数据
   location(){
     //请求对象数据
     let params = {"param":{pageSize:0}, "entity":{systemId:this.systemId.getSystemId()}};
     //请求数据服务
     this.kmsService.queryDictionaryPageList(params).subscribe(data=>{
       if(!data){
         this.modal.toggle()
         this.callback.emit()
       }else if(data["code"] ==200){
         //绑定数据
         this.parentMenu = data["data"]["records"];
       }
     })
   }
 
   //触发初始化方法
   clickLoca(view: string, viewData: any) {
     this.f.reset();
     //新增
     if(view == 'Add'){
       //显示标题
       this.headerLoGo = '新增字典';
       //初始化上级id 
       this.dicModels = {parentId:viewData,sort:1};
     }else{
       //修改
       this.headerLoGo = '修改字典';
       let param = { ids: [viewData.dictionaryId] }  //修改ID值 //取得修改的对象
       this.kmsService.getDictionary(param).subscribe(data => {
         this.dicModels = data["data"];  //绑定表单对象
       })
     }
   }
 
   //提交 保存或者修改
   onSubmit({ value, valid }, event: Event) {
     if (valid) {
       //新增的时候 
       if (this.headerLoGo == "新增字典") {
         value.systemId = this.systemId.getSystemId();
         //请求服务 
         this.kmsService.saveDictionary(value).subscribe(data => {
           if (data["code"] == 200) {
             this.init.inItDictionary(); //初始化字典
             this.location();//重新加载方法
             this.box.success('操作成功'); //提示
             this.modal.toggle();//关闭 弹出框
             this.callback.emit(true);//抛出事件
           }else{
             this.box.danger(data.msg);
             if(data.msg != "字典值重复"){
               this.modal.toggle();//关闭框
               this.callback.emit(false); //抛出事件
             }
           }
         }
       )
       }else{
         //修改的时候触发 ，请求事件
         this.kmsService.updateDictionary(value).subscribe(data => {
           if (data["code"] == 200) {
             this.init.inItDictionary(); //初始化字典
             this.location(); //重新加在方法
             this.box.success('操作成功');
             this.modal.toggle(); //关闭弹出框
             this.callback.emit(true); //抛出事件
           }else{
             this.box.danger(data.msg);
             if(data.msg != "字典值已存在"){
               this.modal.toggle();//关闭框
               this.callback.emit(false); //抛出事件
             }
           }
         }
       )
       }
 
     }else {
       this.invalid = true;
       this.box.waringError('请输入完整且正确的信息')
     }
   }
 
   //初始化 加载树形的方法
   delReload(){
     this.location();
   }
 }
 
